module.exports = __webpack_public_path__ + "img/990recMac1.55dbe67b.png";